import {useArabicRulesInCombineNode} from "@/components/widgets/list_download/common.js";

function washFn(walkedNode, item){
  if(walkedNode.modeData && walkedNode.modeData[item.flag]){
    walkedNode.modeData[item.flag] = useArabicRulesInCombineNode({
      componentName: item.componentName,
      data: walkedNode.modeData[item.flag]
    }).data
  }
}

export function washData(walkedNode){
  if(
    walkedNode._type === 'list_download_style1' ||
    walkedNode._type === 'list_download_style3'
  ){
    [{
      flag: 'downloadList_listItem_left_title',
      componentName: 'text_title',
    },{
      flag: 'downloadList_listItem_left_paragraph',
      componentName: 'text_paragraph',
    }].forEach((item)=>{
      washFn(walkedNode, item)
    })
  }else if(walkedNode._type === 'list_download_style2'){
    [{
      flag: 'downloadList_listItem_left_title',
      componentName: 'text_title',
    },{
      flag: 'downloadList_listItem_right_downloadBtn',
      componentName: 'button_text_icon',
    }].forEach((item)=>{
      washFn(walkedNode, item)
    })
  }else if(walkedNode._type === 'list_download_style4'){
    [{
      flag: 'downloadList_listItem_left_title',
      componentName: 'text_title',
    },{
      flag: 'downloadList_listItem_left_icon',
      componentName: 'button_icon',
    }].forEach((item)=>{
      washFn(walkedNode, item)
    })
  }

}
